import React from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_SPACING } from '@/constants/residents/homeConstants';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { IconStatCard } from './IconStatCard';
import { SectionHeader } from '../SectionHeader';

interface CommunityResourcesSectionProps {
  onMarketplace: () => void;
  onResources: () => void;
  onEvents: () => void;
  onWifi: () => void;
  /** Override individual item wrapper style (e.g. fixed width on mobile) */
  itemStyle?: StyleProp<ViewStyle>;
  style?: StyleProp<ViewStyle>;
}

export const CommunityResourcesSection: React.FC<CommunityResourcesSectionProps> = React.memo(({
  onMarketplace,
  onResources,
  onEvents,
  onWifi,
  itemStyle,
  style,
}) => {
  const { colors } = useThemeColors();

  const items = [
    {
      key: 'marketplace',
      label: 'Marketplace',
      caption: 'Buy, sell & connect',
      iconBg: colors.accent.purpleLight,
      Icon: RESIDENTS_SVG_COMPONENTS.SUPERMARKET,
      iconColor: PRIMITIVE_COLORS.resioPurple,
      onPress: onMarketplace,
    },
    {
      key: 'resources',
      label: 'Resources',
      caption: 'Guides, docs & info',
      iconBg: colors.accent.orangeLight,
      Icon: RESIDENTS_SVG_COMPONENTS.DOCUMENT,
      iconColor: PRIMITIVE_COLORS.warningOrange,
      onPress: onResources,
    },
    {
      key: 'events',
      label: 'Events',
      caption: 'Upcoming community events',
      iconBg: colors.accent.greenLight,
      Icon: RESIDENTS_SVG_COMPONENTS.CALENDAR,
      iconColor: PRIMITIVE_COLORS.successGreen,
      onPress: onEvents,
    },
    {
      key: 'wifi',
      label: 'WiFi',
      caption: 'Connection info & support',
      iconBg: colors.accent.blueBgLight,
      Icon: RESIDENTS_SVG_COMPONENTS.WIFI,
      iconColor: PRIMITIVE_COLORS.resioBlue,
      onPress: onWifi,
    },
  ];

  return (
    <View style={style}>
      <SectionHeader title="My Community" />
      <View style={styles.grid}>
        {items.map((item) => (
          <IconStatCard
            key={item.key}
            label={item.label}
            caption={item.caption}
            iconBg={item.iconBg}
            Icon={item.Icon}
            iconColor={item.iconColor}
            onPress={item.onPress}
            itemStyle={itemStyle}
          />
        ))}
      </View>
    </View>
  );
});

CommunityResourcesSection.displayName = 'CommunityResourcesSection';

const styles = StyleSheet.create({
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: REDESIGN_SPACING.gridGap,
  },
});
